goog.provide('el8.practicedata.unassignedEmails');

goog.require('el8.appservice.notifier');
goog.require('el8.model.base');
goog.require('el8.service.tz');

el8.practicedata.unassignedEmails = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addDateTime('timeReceived');
    _class.addStringProperty('content');
    _class.addStringProperty('emailType');
    _class.addProperty('attachments');
    _class.addIntProperty('fromUserId');

    _class.prototype.asSoyMap = function() {
        var m = {};
        m['id'] = this.getId();
        m['receivedTime'] = el8.service.tz.soyStr(this.getTimeReceived());
        m['content'] = this.getContent();
        m['attachments'] = this.getAttachments();
        m['emailType'] = this.getEmailType();
        return m;
    };

    _class.prototype.assignPatient = function(opts) {
        el8.appservice.notifier.notify("Filing email into patient's chart...");
        $.el8_ajax({
            url: el8.service.urls.get('assignEmail', [this.getId(), opts.patientId]),
            type: 'POST',
            data: {'data': JSON.stringify({})},
            success: function() {
                el8.appservice.notifier.notify("Email successfully filed into patient's chart.");
                if (opts.successCb) { opts.successCb(); }
            }
        });
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); }
    });

    return that;

})();


